import { useMemo } from "react";
import { Box } from "@mui/material";
import StringWiseMetricTable from "../../../../Components/StringWiseMetricTable";
import { buildStringMetricsTableData } from "../../../../Helper/DigitalTwin/StringMetricsHelper";

export default function BatteryOverviewStringv2({ stringsData }) {
    const hasData = Array.isArray(stringsData) && stringsData.length > 0;
    const { columns, rows } = useMemo(() => buildStringMetricsTableData(stringsData), [stringsData]);

    if (!hasData) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <StringWiseMetricTable
                columns={columns}
                rows={rows}
                stickyColumns={[0]}
            />
        </Box>
    );
}
